<div class="col-12" *ngIf="gridload">
  <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid">
  <!-- <ngx-loading [show]="pageload"></ngx-loading> -->
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5>
        <span style="padding-right:15px"></span>
        <i class="fa fa-cogs"></i>
        <b> Manage Permit Applications for {{dataCntrl.carrier.name}} </b></h5>
    </div>
  </div>
  <hr>
  <div class="card border-light shadow-sm">
        <label class="sb-txt">Selected Account</label>
          <div class="row">
            <div class="col-sm-12">
              <!-- <label><strong>Account Balance</strong></label>
              <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.carrier.account_balance"
               readonly /> -->
               <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Account Number</th>
                    <th>Account Name</th>
                    <th>Trading Name</th>
                    <th>Lead User</th>
                    <th>Account Status</th>
                    <th>Account Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <td>{{acc.account_number}}</td>
                  <td>{{acc.account_name}}</td>
                  <td>{{acc.trading_name}}</td>
                  <td>{{acc.link_person}}</td>
                  <td>{{acc.status}}</td>
                  <td class="balance">{{acc.account_balance}}</td>
                </tbody>

             </table>
            </div>
          </div>
        </div>
  <div class="card border-light shadow-sm">
   
      <label class="sb-txt" style="margin-bottom:-20px">Applications for this Account</label>
 
        <br>
          <div class="row">
            <div class="col-md-12">
              <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Application</th>
                    <!--<th>Application Ref</th>-->
                    <th>Permit Type</th>
                   <!--<th>Date Created</th>-->
                    <th>Date Submitted<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                    <th class="numPermit">No of Permits</th>
                    <th class="numPermit">Total Fees</th>
                    <th>Status</th>
                    <th class="btn-show hgt-btn">
                        <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title="" style="width:180px;float: right;">
                          <span title="Add a New Permit Application" class=" btn-add btn btn-primary pull-right" style="width: auto;">Apply for Permit </span>
                        </a>
                      </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of dataCntrl.applications | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                                 
                  
                    <th scope="row">{{ pageSize * (pageNumber - 1) + (i+1) }}</th> 
                    <td>{{item.id}}</td>
                    <!-- <td>{{item.reference_num}}</td> -->
                    <td>{{item.permit_type}}</td>
                    <!--<td>{{item.date_created | date:'y/MM/dd'}}</td>-->
                    <td>{{item.submission_date | date:'dd/MM/yyyy'}}</td>
                    <td class="numPermit">{{item.number_of_permits}}</td>
                    <td class="balance2">{{item.total_fees}}</td>
                    <td>{{item.status_desc}}</td>
                    <td style="width: 100px;">
                          <select class="form-control form-control-sm" id="selectControl" (change)="navigateTo($event.target.value,item)">
                            <option value="" disabled selected>Select</option>
                            <option value="view" class="app-option">View Application</option>
                            <option value="edit" *ngIf="item.permit_type_id != 16 && item.permit_type_id != 32  && item.permit_type_id != 17  && item.permit_type_id != 15  &&(item.status_id < permitStatus2 || item.status_id == permitStatus13 || item.status_id == permitStatus2)" class="app-option" >Edit Application</option>
                            <option value="delete" *ngIf="item.status_id == 1 || item.status_id == 11" class="app-option" >Delete Application</option>
                            <option value="cancelApp" *ngIf="item.status_id != 51||item.status_id != 41 ||item.status_id != 92 " class="app-option" >Cancel Application</option>
                            <!-- <option value="unsubmit" *ngIf="item.status_id == permitStatus2" class="app-option">Un-Submit</option> -->
                            <!-- <option value="completepayment" *ngIf="(item.status_id == permitStatus6 || item.status_id == permitStatus14)" class="app-option">Complete Payment</option> -->
                            <!-- <option class="app-option" value="confirm" >Confirm Details</option> -->
                            <!-- <option class="app-option" value="cancelApp" *ngIf="item.status_id <= PermitStatus10">Cancel Application</option> -->

                          </select>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
              <div style="text-align:center" *ngIf="Count > 10">
                <table border="0" cellpadding="0" cellspacing="0" style="float: right;">
                  <tr>
                    <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                      Show :
                    </td>
                    <td style="white-space: nowrap">
                      <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                        <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                      </select>
                    </td>
                  </tr>
                </table>
                <pagination-controls class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>
              </div>
              <div style="text-align:center" *ngIf="dataCntrl.applications.length <= 0 && loadCompleted">
                <h5>No Applications Found</h5>
              </div>
            </div>
          </div>
        </div>
    <div>
        <div class="card-data">
            <div class="col-md-12">
                <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary pull-right" style="margin-left:10px; "> Back</button>
              </div>
        </div>
    </div>
</div>
